import { render, staticRenderFns } from "./ctr.vue?vue&type=template&id=7ca05ab4&scoped=true"
import script from "./ctr.vue?vue&type=script&lang=js"
export * from "./ctr.vue?vue&type=script&lang=js"
import style0 from "./ctr.vue?vue&type=style&index=0&id=7ca05ab4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca05ab4",
  null
  
)

export default component.exports